import React, { useState } from 'react';
import {
  Box,
  Chip,
  TextField,
  FormHelperText,
  Stack,
} from '@mui/material';

const ChipInput = ({
  value = [],
  onChange = () => {},
  placeholder = 'Type and press Enter to add...',
  helperText = '',
  error = false,
  errorText = '',
  disabled = false,
  label = '',
  fullWidth = true,
}) => {
  const [inputValue, setInputValue] = useState('');

  // Parse value - handle both array and comma-separated string
  const chips = Array.isArray(value) 
    ? value 
    : (typeof value === 'string' ? value.split(',').map(v => v.trim()).filter(Boolean) : []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && inputValue.trim()) {
      event.preventDefault();
      const newValue = inputValue.trim();
      
      // Avoid duplicates
      if (!chips.includes(newValue)) {
        const updatedChips = [...chips, newValue];
        onChange(updatedChips);
      }
      
      setInputValue('');
    }
  };

  const handleDelete = (chipToDelete) => {
    const updatedChips = chips.filter((chip) => chip !== chipToDelete);
    onChange(updatedChips);
  };

  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto' }}>
      <TextField
        fullWidth={fullWidth}
        label={label}
        placeholder={placeholder}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        error={error}
        disabled={disabled}
        sx={{ mb: 1 }}
      />
      
      {chips.length > 0 && (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            flexWrap: 'wrap',
            gap: 1,
            mb: 1,
            p: 1,
            border: '1px solid',
            borderColor: error ? 'error.main' : 'divider',
            borderRadius: 1,
            minHeight: 48,
          }}
        >
          {chips.map((chip, index) => (
            <Chip
              key={index}
              label={chip}
              onDelete={disabled ? undefined : () => handleDelete(chip)}
              color="primary"
              variant="outlined"
              size="small"
            />
          ))}
        </Stack>
      )}
      
      {(helperText || errorText) && (
        <FormHelperText error={error}>
          {error ? errorText : helperText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default ChipInput;




